import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Modal, Btn, Input } from "@/components/erp/ui";
import { Trash2, ChevronUp, Pencil } from "lucide-react";

// Atur daftar kategori stok (dipakai Stok, Inventori, Purchase Request)
export const CategoryManager = ({ open, cats, onClose, onSaved }) => {
  const [list, setList] = useState(cats);
  const [add, setAdd] = useState("");
  useEffect(() => { if (open) { setList(cats); setAdd(""); } }, [open, cats]);
  const save = async () => {
    try { await api.put("/stock-categories", { categories: list }); toast.success("Kategori disimpan"); onSaved(); onClose(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
  };
  const up = (i) => { if (i > 0) { const l = [...list]; [l[i - 1], l[i]] = [l[i], l[i - 1]]; setList(l); } };
  const rename = async (c) => {
    const v = (window.prompt(`Ganti nama kategori "${c}" menjadi:`, c) || "").trim();
    if (!v || v === c) return;
    if (!window.confirm(`Ganti "${c}" → "${v}"? Semua stok, PR & PO dengan kategori ini ikut berubah.`)) return;
    try { const { data } = await api.post("/stock-categories/rename", { old: c, new: v }); const n = Object.values(data.updated || {}).reduce((a, b) => a + b, 0); toast.success(`Kategori diganti — ${n} data ikut diperbarui`); setList(list.map((x) => (x === c ? v : x))); onSaved(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
  };
  return (
    <Modal open={open} onClose={onClose} title="Atur Kategori Stok"
      footer={<><Btn variant="ghost" onClick={onClose}>Batal</Btn><Btn data-testid="cat-save" onClick={save}>Simpan</Btn></>}>
      <p className="text-xs text-slate-500 mb-2">Kategori ini sama untuk Stok, Inventori dan form Purchase Request. Kategori yang masih dipakai stok tidak bisa dihapus. Klik ikon pensil untuk ganti nama — semua stok, PR &amp; PO ikut berubah.</p>
      <div className="space-y-1 max-h-72 overflow-y-auto" data-testid="cat-list">
        {list.map((c, i) => (
          <div key={c} className="flex items-center gap-2 text-sm border-t border-slate-100 py-1" data-testid={`cat-row-${c}`}>
            <span className="w-6 text-xs text-slate-400">{i + 1}</span><span className="flex-1">{c}</span>
            <button type="button" title="Ganti nama" data-testid={`cat-rename-${c}`} onClick={() => rename(c)}><Pencil className="w-4 h-4 text-sky-600" /></button>
            <button type="button" onClick={() => up(i)}><ChevronUp className="w-4 h-4 text-slate-400" /></button>
            <button type="button" data-testid={`cat-del-${c}`} onClick={() => setList(list.filter((x) => x !== c))}><Trash2 className="w-4 h-4 text-rose-500" /></button>
          </div>
        ))}
      </div>
      <div className="flex gap-2 mt-3">
        <Input data-testid="cat-new" value={add} onChange={(e) => setAdd(e.target.value)} placeholder="Kategori baru" />
        <Btn variant="ghost" data-testid="cat-add" onClick={() => { const v = add.trim(); if (v && !list.some((x) => x.toLowerCase() === v.toLowerCase())) { setList([...list, v]); setAdd(""); } }}>Tambah</Btn>
      </div>
    </Modal>
  );
};
